import React from 'react';
import { SVGIcon, SvgIconType } from '@uikit/old/Icon/Icon';
import './Alert.scss';

const DefaultIcons = {
  error: (
    <div>
      <SVGIcon icon="warningRoundedSignIcon" size={16} color="#E53935" />
    </div>
  ),
  warning: (
    <div>
      {' '}
      <SVGIcon icon="errorInputFieldSignIcon" color="#F59E0B" />
    </div>
  ),
  success: (
    <div>
      <SVGIcon icon="checkCircled" color="#16A34A" />
    </div>
  ),
};

const VARIANTS = {
  error: {
    bg: '#FFF1F1',
    border: '#FFE9EC',
    color: '#E53935',
  },
  warning: {
    bg: '#FFFBEA',
    border: '#FFE082',
    color: '#F59E0B',
  },
  success: {
    bg: '#EBF7F3',
    border: '#BBF7D0',
    color: '#16A34A',
  },
};

export default function Alert({
  variant = 'error',
  icon,
  children,
  testId,
}: {
  variant?: string;
  icon?: SvgIconType;
  children: any;
  /** data-testid on the alert root (for ui-automation-tests) */
  testId?: string;
}) {
  const t = VARIANTS[variant];
  const resolvedIcon = icon ?? DefaultIcons[variant];

  return (
    <div
      className="alert-container"
      style={{ backgroundColor: t.bg, color: t.color }}
      data-testid={testId}
    >
      <span className="alert-icon">{resolvedIcon}</span>
      <span className="alert-text">{children}</span>
    </div>
  );
}
